import {
    Container
} from "./Announcement.styled";

const Announcement = () => {
    return (
        <Container>
            Super Deal! Free Shipping on Orders Over 50$
        </Container>
    ) 
}

export default Announcement